package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.roster.SwapRequestDto
import com.evoapps.evoshift.domain.model.SwapRequest
import com.evoapps.evoshift.domain.model.SwapStatus

class SwapRequestMapper {

    fun toDomain(dto: SwapRequestDto): SwapRequest {
        return SwapRequest(
            status = try {
                SwapStatus.valueOf(dto.status)
            } catch (e: Exception) {
                SwapStatus.REQUESTED_BY_OWNER // Fallback
            },
            initiatorUserId = dto.initiatorUserId,
            initiatorName = dto.initiatorName.orEmpty(),
            candidateUserId = dto.candidateUserId,
            candidateName = dto.candidateName,
            managerNote = dto.managerNote,
            createdAt = dto.createdAt,
            initiatorNote = dto.initiatorNote?.takeIf { it.isNotBlank() }
        )
    }

    fun toDto(domain: SwapRequest): SwapRequestDto {
        return SwapRequestDto(
            status = domain.status.name,
            initiatorUserId = domain.initiatorUserId,
            initiatorName = domain.initiatorName.ifEmpty { null },
            candidateUserId = domain.candidateUserId,
            candidateName = domain.candidateName,
            managerNote = domain.managerNote,
            createdAt = domain.createdAt,
            initiatorNote = domain.initiatorNote
        )
    }
}
